import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full min-h-[800px] max-w-[900px] py-2 px-4"
}
const _hoisted_2 = { class: "flex justify-between items-center w-full" }
const _hoisted_3 = { class: "text-neutral-800 font-[700]" }
const _hoisted_4 = { class: "min-h-[200px] flex flex-col gap-2 py-4 px-2" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col justify-center items-center gap-6"
}
const _hoisted_6 = {
  key: 1,
  class: "h-screen bg-neutral-50 pt-32"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ListObjective = _resolveComponent("ListObjective")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
    (!_ctx.loader && _ctx.chapters.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Accordion, { class: "accordion-objective-custom" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter, i) => {
                return (_openBlock(), _createBlock(_component_AccordionTab, { key: i }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("h6", _hoisted_3, _toDisplayString(chapter.name), 1),
                      (_ctx.role == 'TEACHER')
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            id: `chapter-edit-btn`,
                            class: "btn-simple w-10",
                            onClick: ($event: any) => (_ctx.goToEditChapter(chapter.id, 0))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { name: "hi-solid-pencil" })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (chapter.trails.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_EmptyData, {
                              data: true,
                              title: `${_ctx.$t('labels.generic', {
                  pt: 'Nenhum objetivo adicionado',
                  en: 'No objectives added',
                })}`,
                              label: `${_ctx.$t('labels.generic', {
                  pt: 'Os objetivos ficarão listados aqui. Clique em “Adicionar objetivos” para ver esses itens.',
                  en: 'The objectives will be listed here. Click “Add objectives” to view these items.',
                })}`,
                              image: 'empty-objectives.svg',
                              imgSize: "h-40"
                            }, null, 8, ["title", "label", "image"]),
                            (_ctx.role == 'TEACHER')
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  class: "btn-outline-bg-white",
                                  onClick: ($event: any) => (_ctx.goToEditChapter(chapter.id, 1))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Adicionar objetivos",
                    en: "Add objectives",
                  })), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(chapter.trails, (objective, j) => {
                            return (_openBlock(), _createBlock(_component_ListObjective, {
                              key: j,
                              objective: objective,
                              chapter: chapter,
                              courseId: _ctx.courseId,
                              role: _ctx.role
                            }, null, 8, ["objective", "chapter", "courseId", "role"]))
                          }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyData, {
              data: true,
              title: `${_ctx.$t('labels.generic', {
            pt: 'Nenhum capítulo adicionado',
            en: 'No chapter added',
          })}`,
              label: `${_ctx.$t('labels.generic', {
            pt: 'Os capítulos ficarão listados aqui. Clique em “Adicionar capítulo” para ver esses itens.',
            en: 'The chapters will be listed here. Click “Add chapter” to view these items.',
          })}`,
              image: 'empty-chapters.svg',
              imgSize: "h-40"
            }, null, 8, ["title", "label", "image"])
          ])
        ]))
  ]))
}